import React, { useContext, useEffect, useRef } from "react";
import FormType, {
    FieldConfigs,
} from "../../../../../shared/components/FormType";
import { AccountingAccount } from "../../../../../data/entities";
import { ROLE } from "../../../../../data/enums";
import { AuthenticationContext } from "../../../../../provider/AuthenticationProvider";

interface FormContainerProps {
    validated: boolean;
    accountData?: AccountingAccount;
    mergeAccount: Function;
    parentAccounts: AccountingAccount[];
    isCreate?: boolean;
    isParent?: boolean;
}

const FormContainer = ({
    validated,
    accountData,
    mergeAccount,
    parentAccounts,
    isCreate,
    isParent,
}: FormContainerProps) => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    // Suggest parent's type once when parent changes; preserve user override thereafter
    const lastSuggestedParentId = useRef<string | null>(null);
    useEffect(() => {
        if (!accountData?.parent) return;
        // Only suggest if parent actually changed from the last suggestion
        if (lastSuggestedParentId.current === accountData.parent) return;
        const selectedParent = parentAccounts.find(
            (parent) => parent.id === accountData.parent
        );
        if (selectedParent?.type) {
            mergeAccount({ type: selectedParent.type });
            lastSuggestedParentId.current = accountData.parent as string;
        }
    }, [accountData?.parent, parentAccounts, mergeAccount]);

    const parentOptions = parentAccounts.map((account) => ({
        text: `${account.code} - ${account.name}`,
        value: account.id,
    }));

    const fields: FieldConfigs[] = [
        {
            label: "Trạng thái",
            type: "toggle",
            key: "status",
        },
        {
            label: "Số tài khoản",
            type: "text",
            key: "code",
            required: true,
        },
        {
            label: "Tên tài khoản",
            type: "text",
            key: "name",
            required: true,
        },
        {
            label: "Tính chất",
            type: "dropdown",
            key: "type",
            options: [
                { text: "Dư nợ", value: "DU_NO" },
                { text: "Dư có", value: "DU_CO" },
                { text: "Lưỡng tính", value: "LUONG_TINH" },
            ],
            disabled: false,
        },
        {
            label: "Tên tiếng Anh",
            type: "text",
            key: "english_translation",
            required: false,
        },
        {
            label: "Tài khoản tổng hợp",
            type: "dropdown",
            key: "parent",
            options: parentOptions,
            placeholder: "Chọn tài khoản tổng hợp",
            required: isCreate,
            disabled: false,
        },
        {
            label: "Diễn giải",
            type: "text",
            key: "note",
            required: false,
        },
    ];

    const getFields = () => {
        switch (role) {
            case ROLE.MANAGER:
            case ROLE.ACCOUNTANT_MANAGER:
                return fields;
            default:
                return fields.map((item) => ({ ...item, disabled: true }));
        }
    };

    return (
        <FormType
            title={"Thông Tin Tài Khoản Kế Toán"}
            fields={getFields()}
            validated={validated}
            requireData={accountData}
            mergeFormData={mergeAccount}
        />
    );
};

export default FormContainer;
